import SpriteSymbol from "../../../hac-ng/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../hac-ng/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "arrow-inward",
  "use": "arrow-inward-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol fill=\"currentColor\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"arrow-inward\"><path d=\"M10.699 6H13.5c.003-.002.5 0 .5.5s-.5.5-.5.5H9V2.5s0-.5.5-.5c.467 0 .496.439.5.495v2.79L14.285 1l.707.707L10.7 6.001zM7 9H2.5S2 9 2 9.5s.498.502.5.5h2.785L.8 14.485l.707.707L6 10.7v2.805c.004.056.033.495.5.495.5 0 .5-.501.5-.501V9z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol